var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5ZM2.33179 6.52741C2.70542 5.45361 3.37558 4.51864 4.24421 3.82056C4.51209 4.22966 4.97449 4.49991 5.50001 4.49991C6.32844 4.49991 7.00001 5.17148 7.00001 5.99991V6.49991C7.00001 7.60448 7.89545 8.49991 9.00002 8.49991C10.1046 8.49991 11 7.60448 11 6.49991C11 5.55979 11.6487 4.77118 12.5228 4.55719C13.4428 5.61161 14 6.99069 14 8.49992C14 8.84069 13.9716 9.17483 13.917 9.50009H13C11.8954 9.50009 11 10.3955 11 11.5001V13.6973C10.1175 14.2078 9.09276 14.4999 7.99992 14.4999V12.5C7.99992 11.3954 7.10448 10.5 5.99992 10.5C4.89535 10.5 3.99992 9.60457 3.99992 8.5C3.99992 7.50849 3.27841 6.6855 2.33179 6.52741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.d618a03100a71c9e3fd07ac872fced2a.svg";
export { ForwardRef as ReactComponent };